"use client"

import { FileSliders } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileSlidersIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileSlidersIcon = component(Icon)({ as: FileSliders })
